import Api from '@/services/Api'

const HEADERURL = 'inv/posiciones/';


export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },


}